
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magnets-onboarding",
      function () {
        return require("private-next-pages/magnets-onboarding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magnets-onboarding"])
      });
    }
  